import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
	root: {},
	cellStyle: {
		width: '8.25rem',
	},
}));
